module.exports = __webpack_public_path__ + "img/AFMS_DLEFT_CLOSE.52dbdcbd.png";